import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

type Role = "Admin" | "Manager" | "User";

export const RoleGuard: React.FC<{
  allow: Role[];
  children: React.ReactNode;
}> = ({ allow, children }) => {
  const { user } = useAuth();
  const location = useLocation();

  // Pas connecté → retour login
  if (!user) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  // Rôle non autorisé → redirige vers dashboard
  if (!allow.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
